import * as React from 'react';
import './style.css';

import App from 'src/state/App';
import RoomPage from 'src/state/RoomPage';

export default class Section extends React.Component<{
  store: App.Store,
  page: RoomPage,
  title: string,
  bodyPadding?: string,
}> {
  render() {
    const { store, page } = this.props;

    const id = `section-${this.props.title.replace(/ /g, '-')}`;

    const sectionClass = [
      'section',
      page.expandedSections[this.props.title] ? 'expanded' : 'collapsed',
      id,
      this.props.title.toLowerCase().replace(/ /g, '-'),
    ].join(' ');

    return (
      <div className={sectionClass}>
        <div
          className="section-header"
          onClick={() => {
            const bodyEl = document.querySelector(`.${id} .section-body`);

            if (bodyEl) {
              if (!bodyEl.parentElement) {
                throw new Error('Expected parent element');
              }

              const style = (bodyEl as HTMLElement).style;

              if (bodyEl.parentElement.className.split(' ').indexOf('expanded') !== -1) {
                style.height = `calc(${Math.floor(bodyEl.getBoundingClientRect().height)}px - 1.45em)`;

                setTimeout(
                  () => { style.height = ''; },
                  16
                );
              } else {
                const prevClassName = bodyEl.parentElement.className;
                bodyEl.parentElement.className = prevClassName.replace('collapsed', 'expanded');
                const rect = bodyEl.getBoundingClientRect();
                bodyEl.parentElement.className = prevClassName;
                style.height = '0px';

                setTimeout(
                  () => {
                    style.height = `${Math.floor(rect.height)}px`;
                  },
                  16
                );

                setTimeout(
                  () => {
                    style.height = '';
                  },
                  216
                );
              }
            }

            store.dispatchCurrentRoomPage({
              type: 'toggle-section',
              data: this.props.title
            });
          }}
        >
          <div>
            <div>
              <div>
                <div className="arrow">
                  <div className="arrow-content">&#x25bc;</div>
                </div>
                <div>{this.props.title}</div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="section-body"
          style={(
            'bodyPadding' in this.props ?
            { padding: this.props.bodyPadding } :
            {}
          )}
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/ui/Section/index.tsx